import { useEffect } from "react";
import { updateMetaTags } from "../utils/seoUtils";

/**
 * Custom hook to manage meta tags for different pages
 * Usage: useHeadMeta(config);
 *
 * @param {Object} config - Configuration object with title, description, image, url
 */
export const useHeadMeta = (config = {}) => {
  useEffect(() => {
    updateMetaTags(config);

    // Scroll to top when page changes
    window.scrollTo(0, 0);
  }, [config]);
};

export default useHeadMeta;
